import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dlg-edit-validation-state',
  templateUrl: './dlg-edit-validation-state.component.html',
  styleUrls: ['./dlg-edit-validation-state.component.scss'],
})
export class DlgEditValidationStateComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
